import React from 'react';
import { Row, Column } from '../../Common/Grid';
import TmntText from '../../Common/Text/TmntText';
import OrderTotalSummary from '../OrderTotalSummary';
import RnEOrderDetailsCTAGroup from './RnEOrderDetailsCTAGroup';
import NextSteps from './NextSteps';
import { rneOrderDetailsDataProps, rneOrderDetailsDataDefaultProps } from '../props';
import ReturnExchangeItemsContainer from './ReturnExchangeItemsContainer';

export default function RnEOrderDetailsContent({ rneQueryData }) {
  const orderDetailItems = rneQueryData?.orderDetails?.orderDetailItems || {};

  const {
    summary, ctaGroup, nextSteps, rneProducts,
  } = orderDetailItems;

  const {
    items, header, includeTags, exchangeLabel, returnLabel,
  } = rneProducts;

  const { rneSummaryTitleText } = rneQueryData?.textFor || {};

  return (
    <div className="return-details-info-module">
      <Row>
        <Column md="4">
          <div className="return-details__info-module rne-next-steps-container" data-testid="rne-next-steps-container">
            <NextSteps nextSteps={nextSteps} />
          </div>
        </Column>
        <Column md="1">
          {/* {to provide space between the two divs} */}
          <span />
        </Column>
        <Column md="3">
          <div className="return-details__info-module returns-payment-summary" data-testid="rne-details-block">
            <div className="return-details__header_title">
              <h2 className="h3">
                <TmntText tmnt={rneSummaryTitleText} />
              </h2>
            </div>
            <div className="returns-order-summary" data-testid="returns-order-summary">
              <OrderTotalSummary summary={summary} />
            </div>
            <hr />
            <div className="returns-order-cta-group" data-testid="returns-order-cta-group">
              <RnEOrderDetailsCTAGroup ctaGroup={ctaGroup} />
            </div>
          </div>
        </Column>
      </Row>
      {rneProducts && (
      <div className="return-details-items" data-testid="rne-product-container">
        <ReturnExchangeItemsContainer
          items={items}
          headerText={header}
          subHeaderText={includeTags}
          returnExchangeText={exchangeLabel}
          text={returnLabel}
        />
      </div>
      )}
    </div>
  );
}

RnEOrderDetailsContent.propTypes = rneOrderDetailsDataProps;
RnEOrderDetailsContent.defaultProps = rneOrderDetailsDataDefaultProps;
